import {
  FLIGHT_SEARCH_FILTER,
  FLIGHT_LIST,
  FILTERED_FLIGHT_LIST,
  FILTER_TIMES,
  CLEAR_SEARCH_DATA,
  COUNTRY_LIST,
  FILTERED_FILTER_ITEMS,
  HOLDED_FLIGHT_ITEM,
  DOMESTIC_RETURN_HOLDED_FLIGHT_ITEM,
  HOLDED_FLIGHT_RESPONSE,
  FLIGHT_SEARCH_FORM,
  PLAIN_SEARCH_FORM,
  IS_FLIGHT_SEARCHING,
} from "./types";

const initialState = {
  flightList: [],
  filterTimes: [],
  searchFilters: [],
  countryList: [],
  filteredFlightList: [],
  flightFilters: null,
  holdedFlight: {},
  holdedReturnFlight: {},
  holdedFlightResponse: {},
  flightSearchForm: null,
  searchForm: null,
  isFlightSearching: false
};
export function flightReducer(state = initialState, action) {
  switch (action.type) {
    case FLIGHT_LIST:
      return { ...state, flightList: action.payload };
    case FILTER_TIMES:
      return { ...state, filterTimes: action.payload };
    case FLIGHT_SEARCH_FILTER:
      return { ...state, searchFilters: action.payload };
    case FILTERED_FLIGHT_LIST:
      return { ...state, filteredFlightList: action.payload };
    case FILTERED_FILTER_ITEMS:
      return { ...state, flightFilters: action.payload };
    case COUNTRY_LIST:
      return { ...state, countryList: action.payload };
    case CLEAR_SEARCH_DATA:
      return {
        ...state,
        flightList: [],
        filterTimes: [],
        searchFilters: [],
        filteredFlightList: [],
        searchForm: null,
        flightSearchForm: null,
      };
    case HOLDED_FLIGHT_ITEM:
      return { ...state, holdedFlight: action.payload };
    case DOMESTIC_RETURN_HOLDED_FLIGHT_ITEM:
      return { ...state, holdedReturnFlight: action.payload };
    case HOLDED_FLIGHT_RESPONSE:
      return { ...state, holdedFlightResponse: action.payload };
    case FLIGHT_SEARCH_FORM:
      return { ...state, flightSearchForm: action.payload };
    case PLAIN_SEARCH_FORM:
      return { ...state, searchForm: action.payload };
    case IS_FLIGHT_SEARCHING:
      return { ...state, isFlightSearching: action.payload };
    default:
      return state;
  }
}
